/* Onyra · interactions : lots et ajout au panier, tiroir panier, galerie, carrousels, vidéos, dates. */
(() => {
  const reduit = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const attendre = (ms) => new Promise((r) => setTimeout(r, ms));
  const racine = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const url = (chemin) => racine() + chemin;
  const lirePanier = () => fetch(url('cart.js'), { headers: { Accept: 'application/json' } }).then((r) => r.json());
  /* n flacons, chacun sur sa ligne : une propriété cachée (_unite) empêche Shopify de les fusionner en « 2 ». */
  let compteur = 0;
  const unites = (variante, n) =>
    Array.from({ length: n }, () => ({
      id: parseInt(variante, 10),
      quantity: 1,
      properties: { _unite: Date.now().toString(36) + (compteur++).toString(36) },
    }));

  /* Hauteur de l'en-tête fixe : la galerie produit se colle juste dessous. */
  function majEntete() {
    const entete = document.querySelector('.o-header[data-fixe]');
    const h = entete ? Math.round(entete.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--o-entete-h', h + 'px');
  }
  window.addEventListener('resize', majEntete, { passive: true });
  document.addEventListener('DOMContentLoaded', majEntete);
  document.addEventListener('shopify:section:load', majEntete);

  /* ---------- Tiroir panier ---------- */
  class OnyraPanier extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-fermer]')) {
          e.preventDefault();
          this.fermer();
          return;
        }
        const bouton = e.target.closest('[data-retirer], [data-moins], [data-ajouter]');
        if (bouton && !bouton.disabled) {
          e.preventDefault();
          this.changer(bouton);
        }
      });
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.fermer();
        if (e.key === 'Tab') this.garderFocus(e);
      });
      this.lierIcone();
      document.addEventListener('shopify:section:load', () => this.lierIcone());
    }

    lierIcone() {
      const icone = document.getElementById('cart-icon-bubble');
      if (!icone || icone.dataset.oLie) return;
      icone.dataset.oLie = '1';
      icone.setAttribute('role', 'button');
      icone.setAttribute('aria-haspopup', 'dialog');
      icone.addEventListener('click', (e) => {
        e.preventDefault();
        this.ouvrir(icone);
      });
      icone.addEventListener('keydown', (e) => {
        if (e.code === 'Space') {
          e.preventDefault();
          this.ouvrir(icone);
        }
      });
    }

    estOuvert() {
      return this.classList.contains('is-actif');
    }

    ouvrir(declencheur) {
      if (declencheur) this.declencheur = declencheur;
      if (this.estOuvert()) return;
      this.classList.add('is-actif');
      document.documentElement.classList.add('o-sans-defilement');
      requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-ouvert')));
      setTimeout(() => {
        const f = this.querySelector('[data-fermer-bouton]') || this.querySelector('.o-panier__tiroir');
        if (f) f.focus();
      }, 60);
    }

    fermer() {
      if (!this.estOuvert()) return;
      this.classList.remove('is-ouvert');
      document.documentElement.classList.remove('o-sans-defilement');
      const fin = () => {
        this.classList.remove('is-actif');
        if (this.declencheur && document.body.contains(this.declencheur)) this.declencheur.focus();
      };
      if (reduit()) fin();
      else setTimeout(fin, 350);
    }

    garderFocus(e) {
      const tiroir = this.querySelector('.o-panier__tiroir');
      const focusables = tiroir.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
      if (!focusables.length) return;
      const premier = focusables[0];
      const dernier = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === premier) {
        e.preventDefault();
        dernier.focus();
      } else if (!e.shiftKey && document.activeElement === dernier) {
        e.preventDefault();
        premier.focus();
      }
    }

    /* Compatibilité avec les autres sections du thème (ajout rapide, produit mis en avant). */
    getSectionsToRender() {
      return [{ id: 'onyra-panier' }, { id: 'cart-icon-bubble' }];
    }

    setActiveElement(el) {
      this.declencheur = el;
    }

    renderContents(etat) {
      this.rendre(etat && etat.sections);
      this.ouvrir(this.declencheur);
    }

    rendre(sections) {
      if (!sections) return;
      const interieur = (html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const s = doc.querySelector('.shopify-section');
        return s ? s.innerHTML : html;
      };
      if (sections['onyra-panier']) {
        const c = this.querySelector('[data-panier-contenu]');
        if (c) c.innerHTML = interieur(sections['onyra-panier']);
      }
      if (sections['cart-icon-bubble']) {
        const i = document.getElementById('cart-icon-bubble');
        if (i) i.innerHTML = interieur(sections['cart-icon-bubble']);
      }
    }

    async envoyer(chemin, corps) {
      this.classList.add('is-occupe');
      try {
        const reponse = await fetch(url(chemin), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(
            Object.assign({ sections: 'onyra-panier,cart-icon-bubble', sections_url: window.location.pathname }, corps)
          ),
        });
        const donnees = await reponse.json();
        if (!reponse.ok || donnees.status) throw new Error(donnees.description || donnees.message || 'Erreur panier');
        this.rendre(donnees.sections);
        document.dispatchEvent(new CustomEvent('onyra:panier', { detail: donnees }));
        return donnees;
      } finally {
        this.classList.remove('is-occupe');
      }
    }

    /* Un flacon = une ligne. Poubelle : la ligne sort. Moins : une unité de moins sur la ligne.
       Plus : un flacon de plus, sur sa propre ligne. Les prix viennent ensuite de Shopify (la remise des lots
       se recalcule seule), puis on remet le cadeau d'accord avec ce qui reste au panier. */
    async changer(bouton) {
      try {
        let etat;
        if (bouton.dataset.retirer) {
          etat = await this.envoyer('cart/update.js', { updates: { [bouton.dataset.retirer]: 0 } });
        } else if (bouton.dataset.moins) {
          etat = await this.envoyer('cart/update.js', { updates: { [bouton.dataset.moins]: parseInt(bouton.dataset.qte, 10) || 0 } });
        } else if (bouton.dataset.ajouter) {
          await this.envoyer('cart/add.js', { items: unites(bouton.dataset.ajouter, 1) });
        }
        await this.reglerCadeau(etat);
      } catch (err) {
        const erreur = this.querySelector('[data-panier-erreur]');
        if (erreur) erreur.hidden = false;
      }
    }

    /* Le cadeau suit le lot : un sachet par flacon offert (3 au plus, comme la remise « 1 acheté = 1 offert »),
       à partir du nombre de flacons achetés réglé dans Onyra panier. Un lot cassé ajuste ou retire les sachets. */
    async reglerCadeau(etat) {
      const panier = etat && etat.items ? etat : await lirePanier();
      const phare = this.dataset.phare;
      const produitCadeau = this.dataset.cadeauProduit;
      let flacons = 0;
      const cadeaux = [];
      (panier.items || []).forEach((ligne) => {
        if ((ligne.properties && ligne.properties._cadeau) || (produitCadeau && String(ligne.product_id) === produitCadeau)) cadeaux.push(ligne);
        else if (!phare || String(ligne.product_id) === phare) flacons += ligne.quantity;
      });
      const offerts = Math.min(Math.floor(flacons / 2), 3);
      const voulu = offerts >= (parseInt(this.dataset.cadeauMin, 10) || 1) ? offerts : 0;
      const total = cadeaux.reduce((n, l) => n + l.quantity, 0);
      if (voulu > 0 && !cadeaux.length) {
        if (this.dataset.cadeauVariante) await this.envoyer('cart/add.js', { items: [{ id: parseInt(this.dataset.cadeauVariante, 10), quantity: voulu, properties: { _cadeau: 'oui' } }] });
      } else if (cadeaux.length && (total !== voulu || cadeaux.length > 1)) {
        const updates = {};
        cadeaux.forEach((l, n) => (updates[l.key] = n === 0 ? voulu : 0));
        await this.envoyer('cart/update.js', { updates: updates });
      }
    }
  }
  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', OnyraPanier);

  /* ---------- Fiche produit : lots, ajout au panier, barre fixe ---------- */
  class OnyraProduit extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', (e) => {
        if (e.target.name === 'o-lot') this.majLot();
      });
      this.addEventListener('click', (e) => {
        const bouton = e.target.closest('[data-o-ajout]');
        if (bouton && !bouton.disabled) {
          e.preventDefault();
          this.ajouter(bouton);
        }
      });
      if (!this.querySelector('input[name="o-lot"]:checked')) {
        const premier = this.querySelector('input[name="o-lot"]');
        if (premier) premier.checked = true;
      }
      this.majLot();
      this.observerBarre();
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
    }

    lotChoisi() {
      return this.querySelector('input[name="o-lot"]:checked');
    }

    majLot() {
      this.querySelectorAll('.o-lot').forEach((carte) => {
        const input = carte.querySelector('input[name="o-lot"]');
        carte.classList.toggle('is-choisi', !!(input && input.checked));
      });
      const lot = this.lotChoisi();
      const resume = this.querySelector('[data-barre-resume]');
      const prix = this.querySelector('[data-barre-prix]');
      if (resume) resume.textContent = lot ? lot.dataset.resume : '';
      if (prix) prix.textContent = lot ? lot.dataset.prix : '';
    }

    async ajouter(bouton) {
      if (this.occupe) return;
      this.occupe = true;
      const lot = this.lotChoisi();
      const n = lot ? parseInt(lot.dataset.quantite, 10) || 1 : 1;
      const variante = this.dataset.variante;
      const cadeau = lot && lot.dataset.cadeau === '1' ? lot.dataset.cadeauVariante || this.dataset.cadeauVariante : '';

      const panier = document.querySelector('cart-drawer');
      const erreur = this.querySelector('[data-erreur]');
      const statut = this.querySelector('[data-statut]');
      if (erreur) erreur.hidden = true;
      bouton.classList.add('is-charge');
      bouton.setAttribute('aria-busy', 'true');
      const debut = Date.now();
      try {
        /* Choisir un lot remplace le lot déjà au panier (sérum et cadeau), puis chaque flacon arrive sur sa ligne. */
        const actuel = await lirePanier();
        const vider = {};
        (actuel.items || []).forEach((ligne) => {
          if (String(ligne.variant_id) === String(variante) || (ligne.properties && ligne.properties._cadeau)) vider[ligne.key] = 0;
        });
        const items = unites(variante, n);
        if (cadeau) items.push({ id: parseInt(cadeau, 10), quantity: parseInt(lot.dataset.cadeauQuantite, 10) || 1, properties: { _cadeau: 'oui' } });
        if (panier && panier.envoyer) {
          if (Object.keys(vider).length) await panier.envoyer('cart/update.js', { updates: vider });
          await panier.envoyer('cart/add.js', { items: items });
        } else {
          const poster = (chemin, corps) =>
            fetch(url(chemin), {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(corps),
            }).then((r) => {
              if (!r.ok) throw new Error('Erreur panier');
            });
          if (Object.keys(vider).length) await poster('cart/update.js', { updates: vider });
          await poster('cart/add.js', { items: items });
          window.location.href = url('cart');
          return;
        }
        await attendre(Math.max(0, 600 - (Date.now() - debut)));
        bouton.classList.remove('is-charge');
        bouton.classList.add('is-ajoute');
        if (statut) statut.textContent = statut.dataset.texteAjoute || '';
        await attendre(reduit() ? 200 : 650);
        panier.ouvrir(bouton);
        setTimeout(() => {
          bouton.classList.remove('is-ajoute');
          if (statut) statut.textContent = '';
        }, 1200);
      } catch (err) {
        bouton.classList.remove('is-charge');
        if (erreur) erreur.hidden = false;
      } finally {
        bouton.removeAttribute('aria-busy');
        this.occupe = false;
      }
    }

    observerBarre() {
      const barre = this.querySelector('[data-barre]');
      const cible = this.querySelector('.o-achat__bouton');
      if (!barre || !cible || !('IntersectionObserver' in window)) return;
      this.io = new IntersectionObserver(([entree]) => {
        const visible = !entree.isIntersecting && entree.boundingClientRect.top < 0;
        barre.classList.toggle('is-visible', visible);
        barre.setAttribute('aria-hidden', visible ? 'false' : 'true');
        if (visible) barre.removeAttribute('inert');
        else barre.setAttribute('inert', '');
        document.documentElement.classList.toggle('o-barre-visible', visible);
      });
      this.io.observe(cible);
    }
  }
  if (!customElements.get('onyra-produit')) customElements.define('onyra-produit', OnyraProduit);

  /* ---------- Galerie produit ---------- */
  class OnyraGalerie extends HTMLElement {
    connectedCallback() {
      this.piste = this.querySelector('[data-piste]');
      if (!this.piste) return;
      this.diapos = Array.from(this.piste.querySelectorAll('[data-diapo]'));
      this.vignettes = Array.from(this.querySelectorAll('[data-vignette]'));
      this.compteur = this.querySelector('[data-compteur]');
      this.bande = this.querySelector('.o-galerie__vignettes');
      this.prec = Array.from(this.querySelectorAll('[data-galerie-prec]'));
      this.suiv = Array.from(this.querySelectorAll('[data-galerie-suiv]'));
      this.vignettes.forEach((v) => v.addEventListener('click', () => this.aller(parseInt(v.dataset.vignette, 10))));
      /* Les flèches tournent en boucle : avant la première, on revient à la dernière. */
      const n = this.diapos.length;
      this.prec.forEach((b) => b.addEventListener('click', () => this.aller((this.index - 1 + n) % n)));
      this.suiv.forEach((b) => b.addEventListener('click', () => this.aller((this.index + 1) % n)));
      this.piste.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') this.aller(Math.min(this.index + 1, this.diapos.length - 1));
        if (e.key === 'ArrowLeft') this.aller(Math.max(this.index - 1, 0));
      });
      this.index = 0;
      if (this.diapos.length > 1) this.glisserSouris();
      if ('IntersectionObserver' in window && this.diapos.length > 1) {
        this.io = new IntersectionObserver(
          (entrees) => {
            entrees.forEach((e) => {
              if (e.isIntersecting && e.intersectionRatio >= 0.6) this.marquer(parseInt(e.target.dataset.diapo, 10));
            });
          },
          { root: this.piste, threshold: [0.6] }
        );
        this.diapos.forEach((d) => this.io.observe(d));
      }
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
    }

    /* Souris : clic maintenu puis glisser, la photo suit ; au lâcher, elle se cale sur la voisine (au doigt, le défilement natif suffit). */
    glisserSouris() {
      const p = this.piste;
      let x0 = 0;
      let g0 = 0;
      let actif = false;
      p.addEventListener('dragstart', (e) => e.preventDefault());
      p.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        actif = true;
        x0 = e.clientX;
        g0 = p.scrollLeft;
        p.style.scrollSnapType = 'none';
        p.style.scrollBehavior = 'auto';
        p.classList.add('is-glisse');
        p.setPointerCapture(e.pointerId);
      });
      p.addEventListener('pointermove', (e) => {
        if (actif) p.scrollLeft = g0 - (e.clientX - x0);
      });
      const finir = (e) => {
        if (!actif) return;
        actif = false;
        p.classList.remove('is-glisse');
        const dx = e.clientX - x0;
        const seuil = Math.min(80, p.clientWidth * 0.15);
        let i = this.index;
        if (dx < -seuil) i = Math.min(i + 1, this.diapos.length - 1);
        if (dx > seuil) i = Math.max(i - 1, 0);
        this.aller(i);
        setTimeout(() => {
          p.style.scrollSnapType = '';
          p.style.scrollBehavior = '';
        }, 450);
      };
      p.addEventListener('pointerup', finir);
      p.addEventListener('pointercancel', finir);
    }

    aller(i) {
      const diapo = this.diapos[i];
      if (!diapo) return;
      this.piste.scrollTo({ left: diapo.offsetLeft, behavior: reduit() ? 'auto' : 'smooth' });
      this.marquer(i);
    }

    marquer(i) {
      this.index = i;
      this.vignettes.forEach((v, j) => {
        v.classList.toggle('is-active', j === i);
        if (j === i) v.setAttribute('aria-current', 'true');
        else v.removeAttribute('aria-current');
      });
      if (this.compteur) this.compteur.textContent = String(i + 1);
      /* La rangée de vignettes suit (sans faire bouger la page) : la vignette active reste visible. */
      const v = this.vignettes[i];
      const b = this.bande;
      if (v && b && b.scrollWidth > b.clientWidth) {
        if (v.offsetLeft < b.scrollLeft) b.scrollLeft = v.offsetLeft;
        else if (v.offsetLeft + v.offsetWidth > b.scrollLeft + b.clientWidth) b.scrollLeft = v.offsetLeft + v.offsetWidth - b.clientWidth;
      }
    }
  }
  if (!customElements.get('onyra-galerie')) customElements.define('onyra-galerie', OnyraGalerie);

  /* ---------- Carrousel (flèches, points, glisser au doigt) ---------- */
  class OnyraCarrousel extends HTMLElement {
    connectedCallback() {
      this.piste = this.querySelector('[data-piste]');
      if (!this.piste) return;
      this.items = Array.from(this.piste.children);
      this.prec = this.querySelector('[data-prec]');
      this.suiv = this.querySelector('[data-suiv]');
      this.points = this.querySelector('[data-points]');
      if (this.prec) this.prec.addEventListener('click', () => this.page(-1));
      if (this.suiv) this.suiv.addEventListener('click', () => this.page(1));
      this.surDefile = () => {
        cancelAnimationFrame(this.raf);
        this.raf = requestAnimationFrame(() => this.maj());
      };
      this.piste.addEventListener('scroll', this.surDefile, { passive: true });
      this.surTaille = () => this.construire();
      window.addEventListener('resize', this.surTaille, { passive: true });
      this.construire();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.surTaille);
    }

    parVue() {
      const v = parseInt(getComputedStyle(this).getPropertyValue('--o-par-vue'), 10);
      return v > 0 ? v : 1;
    }

    construire() {
      const nb = Math.max(1, Math.ceil(this.items.length / this.parVue()));
      if (this.points && this.nbPages !== nb) {
        this.points.innerHTML = '';
        for (let i = 0; i < nb; i++) this.points.appendChild(document.createElement('span'));
      }
      this.nbPages = nb;
      this.classList.toggle('o-carrousel--seul', nb < 2);
      this.maj();
    }

    pas() {
      const gap = parseFloat(getComputedStyle(this.piste).columnGap) || 0;
      return this.piste.clientWidth + gap;
    }

    indexPage() {
      return Math.min(this.nbPages - 1, Math.max(0, Math.round(this.piste.scrollLeft / this.pas())));
    }

    page(d) {
      const cible = Math.min(this.nbPages - 1, Math.max(0, this.indexPage() + d));
      this.piste.scrollTo({ left: cible * this.pas(), behavior: reduit() ? 'auto' : 'smooth' });
    }

    maj() {
      const i = this.indexPage();
      if (this.points) Array.from(this.points.children).forEach((p, j) => p.classList.toggle('is-active', j === i));
      if (this.prec) this.prec.setAttribute('aria-disabled', i <= 0 ? 'true' : 'false');
      if (this.suiv) this.suiv.setAttribute('aria-disabled', i >= this.nbPages - 1 ? 'true' : 'false');
    }
  }
  if (!customElements.get('onyra-carrousel')) customElements.define('onyra-carrousel', OnyraCarrousel);

  /* ---------- Vidéos story : lecture au toucher ---------- */
  class OnyraVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      const play = this.querySelector('[data-video-play]');
      if (!this.video || !play) return;
      play.addEventListener('click', () => {
        document.querySelectorAll('onyra-video.is-lecture').forEach((autre) => {
          if (autre !== this && autre.video) autre.video.pause();
        });
        this.video.controls = true;
        this.video.play();
      });
      this.video.addEventListener('play', () => this.classList.add('is-lecture'));
      this.video.addEventListener('pause', () => this.classList.remove('is-lecture'));
    }
  }
  if (!customElements.get('onyra-video')) customElements.define('onyra-video', OnyraVideo);

  /* ---------- Accordéons : une seule ligne ouverte à la fois (si demandé) ---------- */
  /* ---------- Lignes dépliables : ouverture et fermeture en douceur ----------
     La hauteur de la ligne est animée (et le contenu apparaît en fondu), au lieu d'apparaître d'un coup.
     Exclusif (réglage du bloc) : ouvrir une ligne referme les autres, en douceur aussi. */
  const DEPLIABLES = 'details.o-acc, details.o-acc__suite, details.o-ingr__liste';
  const enCours = new WeakMap();
  function hauteurFermee(d, resume) {
    const st = getComputedStyle(d);
    return resume.offsetHeight + parseFloat(st.borderTopWidth) + parseFloat(st.borderBottomWidth) + parseFloat(st.paddingTop) + parseFloat(st.paddingBottom);
  }
  function deplier(d, ouvrir) {
    const resume = d.querySelector(':scope > summary');
    const corps = d.querySelector(':scope > :not(summary)');
    const avant = enCours.get(d);
    if (avant) avant.forEach((a) => a.cancel());
    d.dataset.oEtat = ouvrir ? 'ouvert' : 'ferme';
    if (ouvrir) {
      const groupe = d.classList.contains('o-acc') && d.closest('onyra-accordeons[data-exclusif]');
      if (groupe) groupe.querySelectorAll('details.o-acc').forEach((autre) => {
        if (autre !== d && autre.open && autre.dataset.oEtat !== 'ferme') deplier(autre, false);
      });
    }
    if (reduit() || !resume || !d.animate) {
      d.open = ouvrir;
      delete d.dataset.oEtat;
      return;
    }
    const depart = d.offsetHeight;
    if (ouvrir) d.open = true;
    const arrivee = ouvrir ? d.scrollHeight + (d.offsetHeight - d.clientHeight) : hauteurFermee(d, resume);
    d.style.overflow = 'hidden';
    const options = { duration: 340, easing: 'cubic-bezier(.2, .7, .2, 1)' };
    const anims = [d.animate({ height: [depart + 'px', arrivee + 'px'] }, options)];
    if (corps) anims.push(corps.animate(ouvrir ? { opacity: [0, 1], transform: ['translateY(-6px)', 'none'] } : { opacity: [1, 0] }, options));
    enCours.set(d, anims);
    const fin = () => {
      if (enCours.get(d) !== anims) return;
      if (!ouvrir) d.open = false;
      d.style.overflow = '';
      delete d.dataset.oEtat;
      enCours.delete(d);
    };
    anims[0].onfinish = fin;
    setTimeout(fin, options.duration + 80);
  }
  document.addEventListener('click', (e) => {
    const resume = e.target.closest('summary');
    if (!resume) return;
    const d = resume.parentElement;
    if (!(d instanceof HTMLDetailsElement) || !d.matches(DEPLIABLES)) return;
    e.preventDefault();
    const ouvrir = d.dataset.oEtat ? d.dataset.oEtat === 'ferme' : !d.open;
    deplier(d, ouvrir);
  });

  /* Groupe de lignes dépliables : l'exclusivité est gérée par deplier() (une seule ouverte à la fois). */
  class OnyraAccordeons extends HTMLElement {}
  if (!customElements.get('onyra-accordeons')) customElements.define('onyra-accordeons', OnyraAccordeons);

  /* ---------- Chiffres qui montent de 0 à leur valeur à l'arrivée à l'écran ---------- */
  class OnyraCompteur extends HTMLElement {
    connectedCallback() {
      this.anim = this.querySelector('.o-compteur__anim');
      const final = this.querySelector('.o-compteur__final');
      if (!this.anim || !final || reduit() || !('IntersectionObserver' in window)) return;
      this.texteFinal = final.textContent.trim();
      const m = this.texteFinal.match(/^(\D*?)(\d+(?:[.,]\d+)?)(.*)$/);
      if (!m) return;
      this.avant = m[1];
      this.apres = m[3];
      this.decimales = (m[2].split(/[.,]/)[1] || '').length;
      this.virgule = m[2].indexOf(',') > -1;
      this.cible = parseFloat(m[2].replace(',', '.'));
      this.duree = parseInt(this.dataset.duree, 10) || 1400;
      this.anim.textContent = this.formater(0);
      this.io = new IntersectionObserver(
        (entrees) => {
          if (entrees.some((e) => e.isIntersecting)) {
            this.io.disconnect();
            this.lancer();
          }
        },
        { threshold: 0.4 }
      );
      this.io.observe(this);
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      cancelAnimationFrame(this.raf);
    }

    formater(v) {
      let t = v.toFixed(this.decimales);
      if (this.virgule) t = t.replace('.', ',');
      return this.avant + t + this.apres;
    }

    lancer() {
      const debut = performance.now();
      const pas = (maintenant) => {
        const p = Math.min(1, (maintenant - debut) / this.duree);
        const adouci = 1 - Math.pow(1 - p, 3);
        if (p < 1) {
          this.anim.textContent = this.formater(this.cible * adouci);
          this.raf = requestAnimationFrame(pas);
        } else {
          this.anim.textContent = this.texteFinal;
        }
      };
      this.raf = requestAnimationFrame(pas);
    }
  }
  if (!customElements.get('onyra-compteur')) customElements.define('onyra-compteur', OnyraCompteur);

  /* ---------- Date de livraison estimée ---------- */
  class OnyraDate extends HTMLElement {
    connectedCallback() {
      const min = parseInt(this.dataset.min, 10) || 3;
      const max = Math.max(min, parseInt(this.dataset.max, 10) || min);
      const ouvres = this.dataset.ouvres !== 'false';
      const ajouter = (n) => {
        const d = new Date();
        let reste = n;
        while (reste > 0) {
          d.setDate(d.getDate() + 1);
          const j = d.getDay();
          if (!ouvres || (j !== 0 && j !== 6)) reste--;
        }
        return d;
      };
      const format = (d) => new Intl.DateTimeFormat('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' }).format(d);
      const echapper = (t) => t.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
      const modele = echapper(this.dataset.modele || '');
      this.innerHTML = modele
        .replace('[debut]', '<b>' + echapper(format(ajouter(min))) + '</b>')
        .replace('[fin]', '<b>' + echapper(format(ajouter(max))) + '</b>');
    }
  }
  if (!customElements.get('onyra-date')) customElements.define('onyra-date', OnyraDate);
})();
